<div class="app-wrapper top-bar mt-0">
    <main>
        <div class="container-fluid px-2 px-md-4 px-lg-5 py-4 py-xl-5">
            <div class="content-container m-0">
                <div class="d-flex py-4">
                    <div class="login-form mx-auto">
                        <div class="d-flex mb-3 flex-column">
                            <img class="logo p-4" src="/assets/logo-large.svg" alt="MacDonnell Council" />
                        </div>

                        @if (!submitted) {
                            <form (ngSubmit)="doRequest()" #requestForm="ngForm">
                                <h5 class="mb-3">Forgot your password?</h5>
                                @if (error) {
                                    <div class="alert alert-danger" role="alert">Error: {{ error }}</div>
                                }
                                <div class="form-group">
                                    <label for="forgot_email">Email</label>
                                    <input class="form-control" type="email" id="forgot_email" name="email" required [(ngModel)]="form.email" autocomplete="username" />
                                </div>
                                <div class="d-flex">
                                    <input type="submit" value="Send reset link" class="btn btn-primary ms-0 mb-4" [disabled]="!requestForm.form.valid || loading" />
                                </div>
                                <p class="my-0 small"><a routerLink="/login">Back to sign in</a></p>
                            </form>
                        } @else {
                            <h1 class="h4 mb-3">Check your email</h1>
                            <p>If an account exists for that email, we've sent a link to reset the password. The link will expire after a few hours.</p>
                            <p class="my-0 small"><a routerLink="/login">Back to sign in</a></p>
                        }
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>
